/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { LogicModuleImage } from './logicModuleImage';

/**
 * Configuration logic module
 */
export interface LogicModule {
  logicModuleCode?: string;
  image?: LogicModuleImage;
  logicModuleId?: string;
  activated?: boolean;
}
